// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `pre[class*='language-'],
code[class*='language-'] {
    color: #d4d4d4;
    font-size: 13px;
    text-shadow: none;
    font-family: Menlo, Monaco, Consolas, 'Andale Mono', 'Ubuntu Mono', 'Courier New', monospace;
    direction: ltr;
    text-align: left;
    white-space: pre;
    word-spacing: normal;
    word-break: normal;
    line-height: 1.5;
    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;
    -webkit-hyphens: none;
    hyphens: none;
}

pre[class*='language-']::-moz-selection, code[class*='language-']::-moz-selection, pre[class*='language-'] *::-moz-selection, code[class*='language-'] *::-moz-selection {
    text-shadow: none;
    background: #264f78;
}

pre[class*='language-']::selection,
code[class*='language-']::selection,
pre[class*='language-'] *::selection,
code[class*='language-'] *::selection {
    text-shadow: none;
    background: #264f78;
}

@media print {
    pre[class*='language-'],
    code[class*='language-'] {
        text-shadow: none;
    }
}

pre[class*='language-'] {
    padding: 1em;
    margin: 0.5em 0;
    overflow: auto;
    background: #1e1e1e;
}

:not(pre) > code[class*='language-'] {
    padding: 0.1em 0.3em;
    border-radius: 0.3em;
    color: #db4c69;
    background: #1e1e1e;
}
/*********************************************************
* Tokens
*/
.namespace {
    opacity: 0.7;
}

.token.doctype .token.doctype-tag {
    color: #569cd6;
}

.token.doctype .token.name {
    color: #9cdcfe;
}

.token.comment,
.token.prolog {
    color: #6a9955;
}

.token.punctuation,
.language-html .language-css .token.punctuation,
.language-html .language-javascript .token.punctuation {
    color: #d4d4d4;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol,
.token.inserted,
.token.unit {
    color: #b5cea8;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.deleted {
    color: #ce9178;
}

.language-css .token.string.url {
    text-decoration: underline;
}

.token.operator,
.token.entity {
    color: #d4d4d4;
}

.token.operator.arrow {
    color: #569cd6;
}

.token.atrule {
    color: #ce9178;
}

.token.atrule .token.rule {
    color: #c586c0;
}

.token.atrule .token.url {
    color: #9cdcfe;
}

.token.atrule .token.url .token.function {
    color: #dcdcaa;
}

.token.atrule .token.url .token.punctuation {
    color: #d4d4d4;
}

.token.keyword {
    color: #569cd6;
}

.token.keyword.module,
.token.keyword.control-flow {
    color: #c586c0;
}

.token.function,
.token.function .token.maybe-class-name {
    color: #dcdcaa;
}

.token.regex {
    color: #d16969;
}

.token.important {
    color: #569cd6;
}

.token.italic {
    font-style: italic;
}

.token.constant {
    color: #9cdcfe;
}

.token.class-name,
.token.maybe-class-name {
    color: #4ec9b0;
}

.token.console {
    color: #9cdcfe;
}

.token.parameter {
    color: #9cdcfe;
}

.token.interpolation {
    color: #9cdcfe;
}

.token.punctuation.interpolation-punctuation {
    color: #569cd6;
}

.token.boolean {
    color: #569cd6;
}

.token.property,
.token.variable,
.token.imports .token.maybe-class-name,
.token.exports .token.maybe-class-name {
    color: #9cdcfe;
}

.token.selector {
    color: #d7ba7d;
}

.token.escape {
    color: #d7ba7d;
}

.token.tag {
    color: #569cd6;
}

.token.tag .token.punctuation {
    color: #808080;
}

.token.cdata {
    color: #808080;
}

.token.attr-name {
    color: #9cdcfe;
}

.token.attr-value,
.token.attr-value .token.punctuation {
    color: #ce9178;
}

.token.attr-value .token.punctuation.attr-equals {
    color: #d4d4d4;
}

.token.entity {
    color: #569cd6;
}

.token.namespace {
    color: #4ec9b0;
}
/*********************************************************
* Language Specific
*/

pre[class*='language-javascript'],
code[class*='language-javascript'],
pre[class*='language-jsx'],
code[class*='language-jsx'],
pre[class*='language-typescript'],
code[class*='language-typescript'],
pre[class*='language-tsx'],
code[class*='language-tsx'] {
    color: #9cdcfe;
}

pre[class*='language-css'],
code[class*='language-css'] {
    color: #ce9178;
}

pre[class*='language-html'],
code[class*='language-html'] {
    color: #d4d4d4;
}

.language-regex .token.anchor {
    color: #dcdcaa;
}

.language-html .token.punctuation {
    color: #808080;
}
/*********************************************************
* Line highlighting
*/
pre[class*='language-'] > code[class*='language-'] {
    position: relative;
    z-index: 1;
}

.line-highlight.line-highlight {
    background: #f7ebc6;
    box-shadow: inset 5px 0 0 #f7d87c;
    z-index: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/editor/prism-dark.css"],"names":[],"mappings":"AAAA;;IAEI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,4FAA4F;IAC5F,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,qBAAqB;IAGrB,aAAa;AACjB;;AAEA;IAII,iBAAiB;IACjB,mBAAmB;AACvB;;AANA;;;;IAII,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI;;QAEI,iBAAiB;IACrB;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,mBAAmB;AACvB;AACA;;CAEC;AACD;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;;;;;;;IAQI,cAAc;AAClB;;AAEA;;;;;;IAMI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;AACA;;CAEC;;AAED;;;;;;;;IAQI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;AACA;;CAEC;AACD;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,UAAU;AACd","sourcesContent":["pre[class*='language-'],\ncode[class*='language-'] {\n    color: #d4d4d4;\n    font-size: 13px;\n    text-shadow: none;\n    font-family: Menlo, Monaco, Consolas, 'Andale Mono', 'Ubuntu Mono', 'Courier New', monospace;\n    direction: ltr;\n    text-align: left;\n    white-space: pre;\n    word-spacing: normal;\n    word-break: normal;\n    line-height: 1.5;\n    -moz-tab-size: 4;\n    -o-tab-size: 4;\n    tab-size: 4;\n    -webkit-hyphens: none;\n    -moz-hyphens: none;\n    -ms-hyphens: none;\n    hyphens: none;\n}\n\npre[class*='language-']::selection,\ncode[class*='language-']::selection,\npre[class*='language-'] *::selection,\ncode[class*='language-'] *::selection {\n    text-shadow: none;\n    background: #264f78;\n}\n\n@media print {\n    pre[class*='language-'],\n    code[class*='language-'] {\n        text-shadow: none;\n    }\n}\n\npre[class*='language-'] {\n    padding: 1em;\n    margin: 0.5em 0;\n    overflow: auto;\n    background: #1e1e1e;\n}\n\n:not(pre) > code[class*='language-'] {\n    padding: 0.1em 0.3em;\n    border-radius: 0.3em;\n    color: #db4c69;\n    background: #1e1e1e;\n}\n/*********************************************************\n* Tokens\n*/\n.namespace {\n    opacity: 0.7;\n}\n\n.token.doctype .token.doctype-tag {\n    color: #569cd6;\n}\n\n.token.doctype .token.name {\n    color: #9cdcfe;\n}\n\n.token.comment,\n.token.prolog {\n    color: #6a9955;\n}\n\n.token.punctuation,\n.language-html .language-css .token.punctuation,\n.language-html .language-javascript .token.punctuation {\n    color: #d4d4d4;\n}\n\n.token.property,\n.token.tag,\n.token.boolean,\n.token.number,\n.token.constant,\n.token.symbol,\n.token.inserted,\n.token.unit {\n    color: #b5cea8;\n}\n\n.token.selector,\n.token.attr-name,\n.token.string,\n.token.char,\n.token.builtin,\n.token.deleted {\n    color: #ce9178;\n}\n\n.language-css .token.string.url {\n    text-decoration: underline;\n}\n\n.token.operator,\n.token.entity {\n    color: #d4d4d4;\n}\n\n.token.operator.arrow {\n    color: #569cd6;\n}\n\n.token.atrule {\n    color: #ce9178;\n}\n\n.token.atrule .token.rule {\n    color: #c586c0;\n}\n\n.token.atrule .token.url {\n    color: #9cdcfe;\n}\n\n.token.atrule .token.url .token.function {\n    color: #dcdcaa;\n}\n\n.token.atrule .token.url .token.punctuation {\n    color: #d4d4d4;\n}\n\n.token.keyword {\n    color: #569cd6;\n}\n\n.token.keyword.module,\n.token.keyword.control-flow {\n    color: #c586c0;\n}\n\n.token.function,\n.token.function .token.maybe-class-name {\n    color: #dcdcaa;\n}\n\n.token.regex {\n    color: #d16969;\n}\n\n.token.important {\n    color: #569cd6;\n}\n\n.token.italic {\n    font-style: italic;\n}\n\n.token.constant {\n    color: #9cdcfe;\n}\n\n.token.class-name,\n.token.maybe-class-name {\n    color: #4ec9b0;\n}\n\n.token.console {\n    color: #9cdcfe;\n}\n\n.token.parameter {\n    color: #9cdcfe;\n}\n\n.token.interpolation {\n    color: #9cdcfe;\n}\n\n.token.punctuation.interpolation-punctuation {\n    color: #569cd6;\n}\n\n.token.boolean {\n    color: #569cd6;\n}\n\n.token.property,\n.token.variable,\n.token.imports .token.maybe-class-name,\n.token.exports .token.maybe-class-name {\n    color: #9cdcfe;\n}\n\n.token.selector {\n    color: #d7ba7d;\n}\n\n.token.escape {\n    color: #d7ba7d;\n}\n\n.token.tag {\n    color: #569cd6;\n}\n\n.token.tag .token.punctuation {\n    color: #808080;\n}\n\n.token.cdata {\n    color: #808080;\n}\n\n.token.attr-name {\n    color: #9cdcfe;\n}\n\n.token.attr-value,\n.token.attr-value .token.punctuation {\n    color: #ce9178;\n}\n\n.token.attr-value .token.punctuation.attr-equals {\n    color: #d4d4d4;\n}\n\n.token.entity {\n    color: #569cd6;\n}\n\n.token.namespace {\n    color: #4ec9b0;\n}\n/*********************************************************\n* Language Specific\n*/\n\npre[class*='language-javascript'],\ncode[class*='language-javascript'],\npre[class*='language-jsx'],\ncode[class*='language-jsx'],\npre[class*='language-typescript'],\ncode[class*='language-typescript'],\npre[class*='language-tsx'],\ncode[class*='language-tsx'] {\n    color: #9cdcfe;\n}\n\npre[class*='language-css'],\ncode[class*='language-css'] {\n    color: #ce9178;\n}\n\npre[class*='language-html'],\ncode[class*='language-html'] {\n    color: #d4d4d4;\n}\n\n.language-regex .token.anchor {\n    color: #dcdcaa;\n}\n\n.language-html .token.punctuation {\n    color: #808080;\n}\n/*********************************************************\n* Line highlighting\n*/\npre[class*='language-'] > code[class*='language-'] {\n    position: relative;\n    z-index: 1;\n}\n\n.line-highlight.line-highlight {\n    background: #f7ebc6;\n    box-shadow: inset 5px 0 0 #f7d87c;\n    z-index: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
